import {TFunction} from 'i18next';
import * as yup from 'yup';

export interface Location {
  lat: number;
  lng: number;
  label: string;
}

export interface LocationExtended extends Location {
  distance: number;
}

export const defaultLocation = {
  label: 'Köln',
  lat: 50.93836,
  lng: 6.95998
};

export const locationShape = ({t, name}: {t: TFunction; name: string}) =>
  yup.object({
    lat: yup.number().required(),
    lng: yup.number().required(),
    label: yup.string().required(t('validation:is_required', {name}))
  });

export const latLngShape = yup.object({
  lat: yup.number().required(),
  lng: yup.number().required()
});
